import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { CoinProfile, CoinProfileConfig } from "../../../entities/coinGame";
import { getCoinProfile, patchCoinProfile, postCoinProfile } from "./thunks";

interface CoinFlipState {
  loading: boolean;
  saveLoading: boolean;
  profile?: CoinProfile;
  config?: CoinProfileConfig;
}

const initialState: CoinFlipState = {
  loading: false,
  saveLoading: false,
};

export const coinFlipProfileSlice = createSlice({
  name: "coinFlipProfile",
  initialState,
  reducers: {
    clearEntity: (state) => {
      state.profile = undefined;
      state.config = undefined;
    }
  },
  extraReducers: (builder) => {
    // getCoinProfile
    builder.addCase(getCoinProfile.pending, (state) => {
      state.loading = true;
      state.saveLoading = true;
    });
    builder.addCase(getCoinProfile.fulfilled, (state: Draft<CoinFlipState>, actions: PayloadAction<CoinProfile>) => {
      state.loading = false;
      state.saveLoading = false;
      state.profile = actions.payload;
      state.config = actions.payload.config;
    });
    builder.addCase(getCoinProfile.rejected, (state: Draft<CoinFlipState>) => {
      state.loading = false;
      state.saveLoading = false;
    });
    // postCoinProfile
    builder.addCase(postCoinProfile.pending, (state) => {
      state.saveLoading = true;
    });
    builder.addCase(postCoinProfile.fulfilled, (state: Draft<CoinFlipState>, actions: PayloadAction<CoinProfile>) => {
      state.saveLoading = false;
      state.profile = actions.payload;
      state.config = actions.payload.config;
    });
    builder.addCase(postCoinProfile.rejected, (state: Draft<CoinFlipState>) => {
      state.saveLoading = false;
    });
    // patchCoinProfile
    builder.addCase(patchCoinProfile.pending, (state) => {
      state.saveLoading = true;
    });
    builder.addCase(patchCoinProfile.fulfilled, (state: Draft<CoinFlipState>, actions: PayloadAction<CoinProfile>) => {
      state.saveLoading = false;
      state.profile = actions.payload;
      state.config = actions.payload.config;
    });
    builder.addCase(patchCoinProfile.rejected, (state: Draft<CoinFlipState>) => {
      state.saveLoading = false;
    });
  },
});
// export actions
export const { clearEntity } = coinFlipProfileSlice.actions;

export default coinFlipProfileSlice.reducer;
